module.exports = __webpack_public_path__ + "static/media/receive-success-mouse4.149ecc35.png";